angular.module("ticketco/ticketbuyer/events", [
  "ticketco/ticketbuyer/contact_organizer",
  "ticketco/ticketbuyer/item_types",
  "ticketco/ticketbuyer/time_slots",
])
  .config(function (growlProvider) {
    growlProvider.globalDisableCountDown(true);
  });
